import { render, staticRenderFns } from "./FinancialCompany.vue?vue&type=template&id=b98f8dbe&"
import script from "./FinancialCompany.vue?vue&type=script&lang=ts&"
export * from "./FinancialCompany.vue?vue&type=script&lang=ts&"
import style0 from "./FinancialCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports